import api from "../services/api";
import { toast } from 'react-toastify';
import axiosPrivate from "../services/axios/axiosPrivate";
import { goNext } from "./slice/onboardingFormSlice";

export const submitAllFormData = (finalPayload, id,submitType) => {
  return async (dispatch, getState) => {
    dispatch({ type: "API_SUBMIT_REQUEST" });

    try {
      console.log("id", `${api.invitedusers}${id}`);
      const response = await axiosPrivate.post(
        `${api.invitedusers}${id}`,
        finalPayload, {
        headers: {
          'custom-auth-type': 'token'
        }
      }
      );
      if (response?.data?.success === true) {
        toast.success(`${response.data.reason}`, { className: 'toast-success-custom' });
        if(submitType==="saveandnext"){
        setTimeout(() => {
          dispatch(goNext());
        }, 1000);}

      }
      else {
        toast.error(response.data.reason, { className: 'toast-error-custom', autoClose: 5000 });
      }
      dispatch({ type: "API_SUBMIT_SUCCESS", payload: response.data });
      return response.data;
    } catch (error) {
      toast.error("Unable to connect to server", { className: 'toast-error-custom', autoClose: 5000 });
      dispatch({ type: "API_SUBMIT_FAILURE", payload: error.message });
      throw(error);
    }
  };

};
